import styled from 'styled-components';
import { heading } from '@lendi-ui/typography';

export const AccordionHeaderContainer = styled.div``;

export const AccordionHeaderText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${heading({ size: 'xs' })}
`;
